// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EstoqueScreen_Wrapper__3-lV_","Container":"EstoqueScreen_Container__V_f9w"};